import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface InterviewWarningBannerProps {
  className?: string;
}

export default function InterviewWarningBanner({ className }: InterviewWarningBannerProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'fixed bottom-[112px] left-0 right-0 z-[55] p-4 sm:p-6 pointer-events-none',
        className,
      )}
    >
      <div className="flex items-center justify-center max-w-2xl mx-auto">
        <div className="w-14 h-14 flex-shrink-0" />
        <div className="flex-1 flex items-center justify-center">
          <div className="flex max-w-lg items-center justify-center rounded-2xl border border-gray-200 bg-white/95 px-6 py-3 shadow-lg backdrop-blur pointer-events-auto">
            <p className="text-sm text-center text-gray-700">
              {t('Interview.WarningBanner.line1')}
              <br />
              {t('Interview.WarningBanner.line2')}
            </p>
          </div>
        </div>
        <div className="w-14 h-14 flex-shrink-0" />
      </div>
    </div>
  );
}
